import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51643130"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "item__wrapper" }
const _hoisted_3 = { class: "ribbons" }
const _hoisted_4 = { class: "item__info" }
const _hoisted_5 = { class: "item__info-title" }
const _hoisted_6 = { class: "item__info-category uppercase" }


import BaseButton from '@/components/Buttons/BaseButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCatalogItem',
  props: {
  item: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: {name: 'project', params: {id: props.item?.url}},
    class: _normalizeClass(["item", {disabled: props.item?.isBlocked}])
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        class: _normalizeClass(["item__background", {disabled: props.item?.isBlocked}]),
        src: props.item?.thumbnail,
        alt: props.item?.title
      }, null, 10, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (props.item?.description?.premiere)
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 0,
                class: "uppercase",
                bg: "gradient"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("премьера")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (props.item?.description?.soon)
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 1,
                class: "uppercase",
                bg: "gradient"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("скоро")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (props.item?.description?.new_episode)
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 2,
                class: "uppercase",
                bg: "gradient"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("новая серия")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(props.item?.description.title), 1),
          _createElementVNode("h6", _hoisted_6, _toDisplayString(props.item?.description.playlist_spec), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to", "class"]))
}
}

})